import script from "./TheHublot.vue?vue&type=script&setup=true&lang=js"
export * from "./TheHublot.vue?vue&type=script&setup=true&lang=js"

import "./TheHublot.vue?vue&type=style&index=0&id=57664df6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57664df6"]])

export default __exports__